import * as React from "react";
import { memo } from "react";

import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "@hl/shared-features/lib/features/auth/hooks";
import loadable from "@loadable/component";
import { useParams } from "react-router-dom";

import useReferral from "~features/share/useReferral";

import MintPage from "./index";
const MintPageApollo = loadable(
  () => import("../../features/MintPage/MintPageApollo")
);
const MintPageByCollectionId = ({
  isApollo,
  isV1,
}: {
  isApollo?: boolean;
  isV1?: boolean;
}) => {
  const { collectionId } = useParams();
  const { referrerQueryParamValue: referrer } = useReferral();

  const apolloMintPageUpdate = useFeatureFlags(
    FEATURE_FLAGS.APOLLO_MINT_PAGE_UPDATE
  );

  if (isV1 || (!isApollo && !apolloMintPageUpdate)) {
    return <MintPage collectionId={collectionId} referrer={referrer} />;
  }

  return <MintPageApollo collectionId={collectionId} referrer={referrer} />;
};

export default memo(MintPageByCollectionId);
